import consumer from "./consumer";
import {
  escapeStationOrderForHTML,
  truncateAndEscapeHTML
} from "../modules/order_html_sanitizer.mjs";

document.addEventListener("turbo:load", () => {
  const storeOrder = document.querySelector('.store-order');
  const enableSoundButton = document.getElementById("enable-sound");
  
  let subscription;
  let soundEnabled = false;

  if (storeOrder) {
    const storeId = storeOrder.getAttribute('data-store-id');

    if (subscription) {
      subscription.unsubscribe();
    }

    if (enableSoundButton) {
      enableSoundButton.addEventListener("click", () => {
        soundEnabled = true;
        enableSoundButton.style.display = 'none';
      });
    }

    function playNotificationSound() {
      if (soundEnabled) {
        var sound = new Audio('/sounds/ring_order.wav');
        sound.play().then(() => {
          console.log('Sonido reproducido para nueva orden.');
        }).catch((e) => {
          console.error('Error al reproducir el sonido:', e);
        });
      } else {
        console.log("El sonido está deshabilitado o no permitido.");
      }
    }

    subscription = consumer.subscriptions.create(
      { channel: "OrdersChannel", store_id: storeId },
      {
        connected() {
        },

        disconnected() {
        },

        received(data) {
          const ordersList = document.querySelector('.orders-list');
        
          if (data.type === 'new_order' && ordersList) {
            const orderHTML = formatOrderHTML(data.order);
            ordersList.insertAdjacentHTML('beforeend', orderHTML);
            playNotificationSound();
        
            const orderElement = document.getElementById(`order-${data.order.id}`);
            if (orderElement) {
              showVisualAlert(orderElement);
            }
        
          } else if (data.type === 'order_validated') {
            const orderElement = document.getElementById(`order-${data.order_id}`);
            if (orderElement) {
              orderElement.parentElement.remove();
              console.log("Orden eliminada:", data.order_id);
            }
          } else if (data.type === 'order_claimed') {
            // Actualizar botón "Preparar" en todos los dispositivos
            const orderElement = document.getElementById(`order-${data.order_id}`);
            if (orderElement) {
              const claimButton = orderElement.querySelector('.claim-order-btn');
              if (claimButton) {
                claimButton.disabled = true;
                claimButton.classList.remove('btn-prepare');
                claimButton.classList.add('btn-cooking');
                claimButton.innerHTML = `
                  <span class="cooking-icon">🍳</span>
                  <span class="ms-1">Preparando...</span>
                `;
              }

              // Mostrar botón Despachado para delivery
              const dispatchBtn = orderElement.querySelector('.dispatch-order-btn');
              if (dispatchBtn) {
                dispatchBtn.style.display = '';
              }
            }
          } else if (data.type === 'order_refunded') {
            // Full refund - remover orden de cocina
            const orderElement = document.getElementById(`order-${data.order_id}`);
            if (orderElement) {
              orderElement.parentElement.remove();
              console.log("Orden reembolsada completamente, removida:", data.order_id);
            }
          } else if (data.type === 'order_dispatched') {
            const orderElement = document.getElementById(`order-${data.order_id}`);
            if (orderElement) {
              const cardContainer = orderElement.closest('.col-xl-3');
              if (cardContainer) {
                cardContainer.style.transition = 'opacity 0.3s';
                cardContainer.style.opacity = '0';
                setTimeout(() => cardContainer.remove(), 300);
              }
            }
          } else if (data.type === 'order_partial_refund') {
            // Partial refund - actualizar orden con items/cantidades netas
            const orderElement = document.getElementById(`order-${data.order.id}`);
            if (orderElement) {
              updateOrderWithRefund(orderElement, data.order);
              console.log("Orden actualizada por refund parcial:", data.order.id);
            }
          }
        }
      }
    );
  }

  document.addEventListener('turbo:before-cache', () => {
    if (subscription) {
      subscription.unsubscribe();
      console.log("Desuscrito antes de cambiar la vista con Turbo");
    }
  });

  function formatOrderHTML(order) {
    order = escapeStationOrderForHTML(order);

    const orderItemsHTML = (order.order_items || []).map(item => {
      const ingredientsHTML = renderIngredientsHTML(item);
      const descriptionHTML = truncateAndEscapeHTML(item.product?.description_as_plain_text, 50);

      return `
        <div class="list-group-item">
          <div class="item-header small">
            <span class="quantity-badge">${item.quantity || 1}x</span>
            ${item.product?.name || 'Producto'}
          </div>
          
          ${descriptionHTML ? `
            <div class="item-description small">
              ${descriptionHTML}
            </div>
          ` : ''}

          ${ingredientsHTML ? `
            <div class="mt-1">
              ${ingredientsHTML}
            </div>
          ` : ''}
        </div>
      `;
    }).join('');

    const updatedDate = new Date(order.paid_at || order.created_at || Date.now());
    const monthNames = ['', 'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
                      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const formattedDate = `${updatedDate.getDate()} de ${monthNames[updatedDate.getMonth() + 1]} - ${updatedDate.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit', hour12: false })}`;

    const isPresencial = order.payment_method_code === 'cash_register';
    const isDelivery = order.order_type === 'delivery';

    // Botón Preparar - Top
    const claimHTML = `
      <div class="order-claim p-2 border-bottom">
        ${order.state === 'in_process' ? `
          <button class="btn btn-cooking claim-order-btn w-100 btn-sm" 
                  data-order-id="${order.id}" 
                  disabled>
            <span class="cooking-icon">🍳</span>
            <span class="ms-1">Preparando...</span>
          </button>
        ` : `
          <button class="btn btn-prepare claim-order-btn w-100 btn-sm" 
                  data-order-id="${order.id}">
            Preparar <i class="bi bi-arrow-right ms-1"></i>
          </button>
        `}
      </div>
    `;

    // Botón Notificar/Despachar - Bottom
    let actionsHTML;
    if (isDelivery) {
      actionsHTML = `
        <div class="order-actions">
          <button class="btn btn-delivery dispatch-order-btn w-100 btn-sm" 
                  data-order-id="${order.id}" style="display:none;">
            <i class="bi bi-send me-1"></i> Despachado
          </button>
        </div>
      `;
    } else {
      let innerHTML;
      if (order.state === 'ready') {
        // Ya está lista: solo Notificar
        if (order.notified_at) {
          innerHTML = `<button class="btn btn-outline-secondary notify-customer-btn w-100 btn-sm" disabled>
            <i class="bi bi-check-circle me-1"></i>Notificación enviada
          </button>`;
        } else {
          innerHTML = `<button class="btn btn-outline-success notify-customer-btn w-100 btn-sm"
                               data-order-id="${order.id}">
            <i class="bi bi-bell me-1"></i>Notificar
          </button>`;
        }
      } else {
        // No está lista: solo Orden Lista
        innerHTML = `<button class="btn ${isPresencial ? 'btn-notify-presencial' : 'btn-notify-online'} mark-ready-btn w-100 btn-sm"
                             data-order-id="${order.id}">
            <i class="bi bi-check2-circle me-1"></i>Orden Lista
          </button>`;
      }

      actionsHTML = `
        <div class="order-actions">
          ${innerHTML}
        </div>
      `;
    }

    // Botón Entregada (solo pickup, no delivery)
    const deliverHTML = !isDelivery ? `
      <div class="order-deliver">
        <button class="deliver-order-btn" data-order-id="${order.id}">
          <i class="bi bi-check2"></i> Entregada
        </button>
      </div>
    ` : '';

    const cardClass = isDelivery ? 'order-delivery' : (isPresencial ? 'order-presencial' : '');
    const badgeClass = isDelivery ? 'badge-delivery' : (isPresencial ? 'badge-presencial' : 'bg-color-green');
    const badgeText = isDelivery ? 'delivery' : (isPresencial ? 'presencial' : 'online');

    return `
      <div class="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
        <div class="order-card ${order.state === 'ready' ? 'order-notified' : ''} ${cardClass}" id="order-${order.id}">
          
          <!-- Botón Preparar - Top -->
          ${claimHTML}

          <!-- Order Header -->
          <div class="order-header">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <div class="order-number text-muted">
                  <i class="bi bi-receipt me-1 text-primary"></i>
                  #${order.order_number}
                </div>
                <div class="store-name text-muted small">
                  <i class="bi bi-shop-window me-1 text-info"></i>
                  ${order.store?.name || ''}
                </div>
                <div class="order-time small">
                  ${formattedDate}
                </div>
              </div>
              <div>
              <span class="badge ${badgeClass}" id="order-status">
                  ${badgeText}
                </span>
              </div>
            </div>
            
            <div class="d-flex justify-content-between align-items-center mt-1">
              <div class="customer-info small">
                <i class="bi bi-person-circle me-1 text-secondary"></i>
                ${order.account?.name || ''} ${order.account?.last_name || ''}
              </div>
              <div class="order-total color-green fw-bold">
                ${formatCurrency(order.total)}
              </div>
            </div>
          </div>

          <!-- Order Items -->
          <div class="order-items">
            ${orderItemsHTML}
          </div>

          <!-- Order Actions -->
          ${actionsHTML}

          <!-- Entregada -->
          ${deliverHTML}
        </div>
      </div>
    `;
  }

  function showVisualAlert(orderElement) {
    orderElement.classList.add("new-order-alert");
    setTimeout(() => {
      orderElement.classList.remove("new-order-alert");
    }, 8000); 
  }

  function formatCurrency(value) {
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value);
  }

  // Renderiza HTML de ingredientes para un item usando ingredients_display_data
  function renderIngredientsHTML(item) {
    const data = item.ingredients_display_data;
    if (!data || data.length === 0) return '';

    return data.map(comp => {
      const showHeader = typeof comp.component === 'string' && comp.component.trim() !== '';
      const indentClass = showHeader ? 'ms-2' : '';

      const categoriesHTML = (comp.categories || []).map(cat => `
        <div class="mb-1 ${indentClass}">
          <strong class="small color-green">${cat.category}:</strong>
          <div class="ingredients-compact">
            ${cat.ingredients.map(ing => {
              const label = ing.price > 0 ? `${ing.name} ($${ing.price})` : ing.name;
              const display = ing.quantity > 1 ? `${label} ×${ing.quantity}` : label;
              return `
                <span class="ingredient-tag small">
                  <i class="bi bi-check-circle-fill color-green me-1"></i>
                  ${display}
                </span>`;
            }).join('')}
          </div>
        </div>
      `).join('');

      const headerHTML = showHeader
        ? `<strong class="small color-green">${comp.component} #${comp.instance + 1}:</strong>`
        : '';

      return `
        <div class="mb-2">
          ${headerHTML}
          ${categoriesHTML}
        </div>`;
    }).join('');
  }

  // Actualiza una orden existente después de un refund parcial
  function updateOrderWithRefund(orderElement, order) {
    order = escapeStationOrderForHTML(order);

    // Actualizar total
    const totalElement = orderElement.querySelector('.order-total');
    if (totalElement) {
      totalElement.textContent = formatCurrency(order.total);
    }

    // Actualizar items - reconstruir la lista usando la función compartida
    const itemsContainer = orderElement.querySelector('.order-items');
    if (itemsContainer && order.order_items) {
      const newItemsHTML = (order.order_items || []).map(item => {
        const ingredientsHTML = renderIngredientsHTML(item);

        return `
          <div class="list-group-item">
            <div class="item-header small">
              <span class="quantity-badge">${item.quantity || 1}x</span>
              ${item.product?.name || 'Producto'}
            </div>
            ${ingredientsHTML ? `
              <div class="mt-1">
                ${ingredientsHTML}
              </div>
            ` : ''}
          </div>
        `;
      }).join('');

      itemsContainer.innerHTML = newItemsHTML;
    }

    // Agregar indicador visual de refund
    orderElement.classList.add('order-refunded-partial');
    setTimeout(() => {
      orderElement.classList.remove('order-refunded-partial');
    }, 5000);
  }
});
